export const stripHtmlTags = (htmlString) => {
    const tempElement = document.createElement('div')
    tempElement.innerHTML = htmlString
    return tempElement.textContent || tempElement.innerText || ''
}
